import type { AnalyticsEventData } from './types';
import { trackGoogleEvent } from './providers/google';
import { trackUmamiEvent } from './providers/umami';

/** -- Record a custom event on all configured analytics providers. */
export function trackEvent(
  event: string,
  data?: AnalyticsEventData
): void {
  if (typeof window === 'undefined') return;
  trackUmamiEvent(event, data);
  trackGoogleEvent(event, data);
}
